export const APP_NAME = "پل دیزاینــرز";
export const MIN_DESKTOP_SIZE = 1024;
// export const IMAGE_URL = "http://deadfire.xyz/images/";
export const IMAGE_URL = "";
export const LOCAL_IMAGE_URL = "/images/";
export const PLACEHOLDER_IMAGE_URL = LOCAL_IMAGE_URL+"image-placeholder.webp";

export const REQ_TYPES = {
    POST : "post",
    GET : "get",
};

export const EMOJI_IMAGES = [
    "emoji-pic-0.webp",
    "emoji-pic-1.webp",
    "emoji-pic-2.webp",
    "emoji-pic-3.webp",
    "emoji-pic-4.webp",
    "emoji-pic-5.webp",
]
